import { dayOfDate, monthOfDate, formatDateByDay } from "helpers/formatDate";

function getEventDates(event) {
  const dayFrom = dayOfDate(event.from_date);
  const dayTo = dayOfDate(event.to_date);

  if (dayFrom === dayTo) return dayFrom;

  return dayFrom + " - " + dayTo;
}

function getEventMonth(event) {
  const monthFrom = monthOfDate(event.from_date);
  const monthTo = monthOfDate(event.to_date);

  if (monthFrom === monthTo) return monthFrom;

  return monthFrom + " - " + monthTo;
}

function getEventDateRange(event) {
  const from = formatDateByDay(event.from_date);
  const to = formatDateByDay(event.to_date);

  if (from === to) return from;

  return from + " - " + to;
}

export { getEventMonth, getEventDates, getEventDateRange };
